<template>
    <div>
        <Field :name="name" v-slot="{field}">
            <div class="flex flex-col gap-1">
                <label :for="name" :class="['text-sm font-bold', labelClass]">{{ label }}</label>
                <InputText :id="name" v-bind="field" :type="type" :class="[
                    'p-3 border border-[#0070b7] rounded-lg w-full' , inputClass
                ]" :placeholder="placeholder" />
            </div>
        </Field>
        <ErrorMessage :name="name" class="text-red-600 text-xs font-semibold capitalize" />
    </div>
</template>

<script setup lang="ts">
import InputText from 'primevue/inputtext';
import { ErrorMessage, Field } from 'vee-validate';
defineProps({
    name : {
        type: String,
        required: true,
    },
    label : {
        type: String,
        default: "",
    },
    type: {
        type: String,
        default: 'text',
    },
    inputClass: {
        type: String,
        default: '',
    },
    labelClass: {
        type: String,
        default: '',
    },
    placeholder :{
        type: String,
        default: '',
    }
})
</script>